export function interpolate(template: string, params: { [key: string]: any }) {
	const regex = /{{([a-z0-9_][\.a-z0-9_]*)}}/gim;
	return template.replace(regex, function (_, ref) {
		for (const property of ref.split('.')) {
			return params[property];
		}
	});
};
